import { render } from "./DireccionPostal.vue?vue&type=template&id=410c6432&scoped=true"
import script from "./DireccionPostal.vue?vue&type=script&lang=js"
export * from "./DireccionPostal.vue?vue&type=script&lang=js"

import "./DireccionPostal.vue?vue&type=style&index=0&id=410c6432&scoped=true&lang=css"

import exportComponent from "/Users/anfloman/Desktop/ComponentesAlgoritmica/TemaWordpress/tema/vuejs/QuoteAndBuy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410c6432"]])

export default __exports__